import {
    ReconciliationOutlined, FieldTimeOutlined, SwapOutlined,
    DashboardOutlined, ArrowLeftOutlined, ArrowDownOutlined, DownOutlined, EditOutlined, CloseOutlined, CheckOutlined, DeleteOutlined, BugOutlined
} from '@ant-design/icons';
import { Space, Slider, Input, Tag, Dropdown } from 'antd';
import axios from 'axios';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React, { useEffect, useState, useRef, useCallback, createRef } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import { get, post } from "../Libraries/Ajax/HttpService";
import { Select } from 'antd';
import * as htmlToImage from 'dom-to-image-more';

// import { RangeStepInput } from 'react-range-step-input';
import {

    XAxis,
    YAxis,
    CartesianGrid,
    LineChart,
    Legend,
    Tooltip,
    Line,
    Label,
    Dot,
    Bar,
    BarChart,
    ResponsiveContainer,

} from "recharts";
import { Spin } from 'antd';
import Examples from "./multipleselectDropdownagg";
import { CSVLink } from "react-csv";
// import * as htmlToImage from 'html-to-image';
import { toast } from "react-toastify";
import back from '../assets/images/back.svg';
import download from '../assets/images/download.svg';
import { useNavigate } from 'react-router-dom';
import { useDistrict } from "../utils/DistrictContext";
function Anomaly() {
    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY/MM/DD';
    const weekFormat = 'MM/DD';
    const [show, setshow] = useState(false);
    const domEl = useRef(null);
    const [first, setfirst] = useState(false);
    const [toggle, setToggle] = useState(false);

    const [defaultOption, setDefaultOption] = useState("custom");
    const [defaultOptionss, setDefaultOptionss] = useState("Category");
    const [defaultCategory, setDefaultCategory] = useState("industrial");
    const { Option } = Select;
    const [parameterthree, setParameterthree] = useState(null);
    const [callData, setcallData] = useState([]);
    const [response, setResponse] = useState([]);
    const [color, setColor] = useState([]);
    const [data, setData] = useState([null]);
    const [nerge, setNerge] = useState([null]);
    const [aggregateData, setAggregateData] = useState([null]);
    const [aggregateDatas, setAggregateDatas] = useState([null]);
    const [nerges, setNerges] = useState([null]);
    // const [getAreaPng, { ref: areaRef }] = useCurrentPng();
    const [mergenew, setMergenew] = useState([null]);
    const [test, setTest] = useState([]);
    const arryDatas = [];
    const arryDatass = [];
    const arryDatasstwo = [];
    const arryDatassnew = [];
    const users = [];
    const [parameterone, setParameterone] = useState(null);
    const [parametertwo, setParametertwo] = useState(null);
    const [optionone, setOptionone] = useState(["Weekday"]);
    const [optiononenew, setOptiononenew] = useState(["Day"]);
    const [myDatas, setmyDatas] = useState([]);
    const [myData, setmyData] = useState([]);
    const [mySample, setmySample] = useState([]);
    const [myAggregate, setmyAggregate] = useState([]);
    const [myAggregatedummy, setmyAggregatedummy] = useState([]);
    const [slvalue, setSlvalue] = useState(1);
    const [value, setvalue] = useState(1);
    const [slmax, setSlmax] = useState(4);
    const [count, setCount] = useState(0);
    const [messagecount, setMessagecount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const [listOfUsers, setListofUsers] = useState([]);
    const [listOfUserss, setListofUserss] = useState([]);
    const [listOfCategory, setListofCategory] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [previousResLength, setPreviousResLength] = useState(0);
    const [disabledEndDate, setDisabledEndDate] = useState(null);
    const [datastatusaccontability, setDatastatusaccountability] = useState(false);
    const [datastatusanomaly, setDatastatusanomaly] = useState(false);
    const [showInputs, setShowInputs] = useState(Array(10).fill(true)); // Assuming 10 inputs, change the number as needed
    const [inputValues, setInputValues] = useState(Array(10).fill(''));
    const { selectedDistrict } = useDistrict();
    const navigate = useNavigate();
    const domEls = useRef([]);
    const onClickContent = (index) => {
        const updatedInputs = [...showInputs];
        updatedInputs[index] = !updatedInputs[index]; // Toggle the state of the clicked input field
        setShowInputs(updatedInputs);
    };


    const onClickValue = (index) => {
        const updatedInputss = [...showInputs];
        updatedInputss[index] = !updatedInputss[index];
        setShowInputs(updatedInputss);
    };
    const onClickClose = (index) => {
        const updatedInputs = [...showInputs];
        updatedInputs[index] = true;
        setShowInputs(updatedInputs);

        const newInputValues = [...inputValues];
        newInputValues[index] = '';
        setInputValues(newInputValues);
    };

    const handleInputChange = (event, index) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = event.target.value;
        setInputValues(newInputValues);
    };
    //   
    const inputRef = useRef(null);
    const controller = new AbortController();
    const signal = controller.signal;
    const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
    
    const incrementCount = () => {
        setCount(count + 1);
    };

    const onchanges = (value, dateString) => {

        setParameterthree(dateString);

    };
    const onRedirection = (event) => {
        navigate(-1);
    }


    const onchange = (value, dateString) => {

        setParameterone(dateString[0]);
        setParametertwo(dateString[1]);
        const startDate = moment(dateString[0]);
        const endDate = moment(dateString[1]);
        const diffInDays = endDate.diff(startDate, 'days');
        console.log("------diffInDays-------sss-------", diffInDays)
        if (diffInDays > 90) {
            setDisabledEndDate(moment(dateString[0]).add(90, 'days'));
        } else {
            setDisabledEndDate(null);
        }

        var diff = (((new Date(parametertwo) - new Date(parameterone)) / (1000 * 60 * 60 * 24) / 7) / 2);

        setvalue(Math.floor(((new Date(parametertwo) - new Date(parameterone)) / (1000 * 60 * 60 * 24) / 7)));
        setSlmax(diff);


    }

    const onSelects = event => {
        if (event == "account")
            setDefaultOptionss("Account");
        else if (event == "category")
            setDefaultOptionss("Category");

    };
    const onSelectCategory = event => {
        setDefaultCategory(event);

    };
    const sliderChange = (event) => {

        setSlvalue(event.target.value);
    }
    const onMouseClick = event => {

        setDefaultOption(event.target.value);
        setOptiononenew("Day");


    };
    const radioChanges = event => {
        setOptionone(event.target.id);


    };
    const radioChange = event => {

        event.stopPropagation();
        setSlvalue(1);
        setOptiononenew(event.target.id);

    };


    const handleFlowPageclick = () => {
        console.log("flow Analytics")
        navigate('/totalflow');
    }
    const handlePredictivePageclick = () => {
        console.log("Predictive Analytics")
        navigate('/predictiveanalysis');
    }
    const handleAnomalypageclick = () => {
        console.log("Anomaly Analytics")
    }
    const handleDownloadCSV = async (category, account, startDate, endDate) => {
        try {
            const response = await get('apis/download/anomaly', {
                params: {
                    meter: category,
                    start_date: startDate || '',
                    end_date: endDate || '',
                },
                responseType: 'blob',
            });


            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${account}-${JSON.parse(localStorage.getItem("MCData"))?.selectedDistrict?.toString()} Anomaly.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading CSV:', error);
        }
    };
    // const downloadImage = async (index) => {
    //     const element = domEls.current[index];
    //     if (!element) {
    //         toast.error("Chart not found");
    //         return;
    //     }

    //     try {
           
    //          const dataUrl = await htmlToImage.toPng(element, {
    //          backgroundColor: '#ffffff' 
    //          });
    //         const link = document.createElement('a');
    //         const account = data[index]?.account || 'graph';
    //         link.download = `${account}-Anomaly.png`;
    //         link.href = dataUrl;
    //         link.click();
    //     } catch (error) {
    //         console.error("Image download error:", error);
    //         toast.error("Failed to download image");
    //     }
    // };
    const downloadImage = async (index) => {
    const element = domEls.current[index];
    if (!element) {
        toast.error("Chart not found");
        return;
    }

    // Measure element size explicitly
    const rect = element.getBoundingClientRect();
    const width = Math.ceil(rect.width);
    const height = Math.ceil(rect.height);

    try {
        const dataUrl = await htmlToImage.toPng(element, {
            backgroundColor: '#ffffff',
            cacheBust: true,
            width,
            height,
            style: {
                width: `${width}px`,
                height: `${height}px`,
                overflow: 'visible',
                transform: 'none',
                display: 'block',
                backgroundColor: '#ffffff',
            },
            
        });

        const link = document.createElement('a');
        const account = data[index]?.account || 'graph';
        link.download = `${account}-${JSON.parse(localStorage.getItem("MCData"))?.selectedDistrict?.toString()}-Anomaly.png`;
        link.href = dataUrl;

        // Append and click required for Firefox
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error("Image download error:", error);
        toast.error("Failed to download image");
    }
};
    // useEffect(() => {
    // const isMizuWatch = window.location.href.includes("mizuwatch.com");
    // document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
    // }, []);
    useEffect(() => {
        var user = JSON.parse(localStorage.getItem("MCData"));
        var userid = user?.userid;

        get(`apis/alert_status?user_id=${userid}`).then(
            (response) => {
                console.log(response.data.data.accountability_alert_status);
                setDatastatusaccountability(response.data.data.accountability_alert_status);
                setDatastatusanomaly(response.data.data.anomaly_alert_status);

            }
        );

    }, [datastatusaccontability], [datastatusanomaly],[selectedDistrict]
    )
    useEffect(() => {
        var user = JSON.parse(localStorage.getItem("MCData"));
        var userid = user?.userid;


        if (datastatusanomaly === true) {
            post(`apis/alert_status_change?user_id=${userid}&anomaly_seen=true`).then(
                (response) => {


                }
            );
        }
    },
    )
    useEffect(
        () => {
            const differenceInMilliseconds = new Date(parametertwo) - new Date(parameterone);
            const differenceInDays = differenceInMilliseconds / (1000 * 3600 * 24);

            if (differenceInDays < 1090) {
                get(`apis/anoamaly_detection?start_date=${parameterone}&end_date=${parametertwo}`)
                    .then(response => {
                        setData(response?.data?.data);
                    });

            }
            else {
                toast.error('Exceed maximum date range limit of 90 days.')
            }


        },
        [parameterone, parametertwo,selectedDistrict],
    );




    useEffect(() => {

    }, [data,selectedDistrict]);




    return (
        <>
            {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
            <Header />
            <Main>
                <div className="waterDetails" >
                    <div className="d-flex justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <img src={back} alt="" style={{ width: '10px', cursor: 'pointer' }} onClick={onRedirection} />
                            <div className='d-flex align-items-center'>
                                <div className="new-box-padding   align-self-center c-pointer "
                                    onClick={handleFlowPageclick}
                                    style={{
                                        borderBottom: '2px solid #ccc',
                                    }}

                                >
                                    Flow Analytics{datastatusaccontability === true ? <span className="ms-2" style={{ color: 'red' }}>!</span> : ""}
                                </div>
                                <div className="" style={{ width: '2px', height: '25px', background: '#ccc' }}></div>
                                <div className="new-box-padding   align-self-center c-pointer"
                                    onClick={handlePredictivePageclick}
                                    style={{
                                        borderBottom: '2px solid #ccc',
                                    }}
                                >
                                    Predictive Analytics
                                </div>
                                <div className="" style={{ width: '2px', height: '25px', background: '#ccc' }}></div>
                                <div className="new-box-padding  text-blue  align-self-center c-pointer"
                                    onClick={handleAnomalypageclick}
                                    style={{
                                        borderBottom: '2px solid #1998f0',
                                        borderRadius: '0'
                                    }}
                                >
                                    Anomaly Detection{datastatusanomaly === true ? <span className="ms-2" style={{ color: 'red' }}>!</span> : ""}
                                </div>
                            </div>
                        </div>
                        {/*  */}
                        <div className='d-flex align-items-center'>
                            <div className="selectCalender py-1 me-4">
                                <Space direction="horizontal" size={1} className="custom-date anomaly-sty">

                                    <RangePicker onChange={onchange} separator={<SwapOutlined />} />

                                </Space>
                            </div>

                        </div>
                    </div>
                    <div className="col-12 col-lg-12 water-chartLists bg-white" style={{ borderRadius: '16px' }}>
                        <div className="col-12 pb-5"  >
                            <div className=" pt-4 h-100">

                                <div className='row'>
                                    {data.map((dataKey, index) => (

                                           <div className='col-lg-6 col-md-12' key={index}>
                                            <div className="graph-wrapper" style={{ position: 'relative', border: '1px solid #eee', borderRadius: 12, marginBottom: 20 }}>
                                                <Dropdown
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    menu={{
                                                        items: [
                                                            {
                                                                label: (
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            downloadImage(index);
                                                                        }}
                                                                    >
                                                                        Download as PNG
                                                                    </a>
                                                                ),
                                                                key: `png-${index}`,
                                                            },
                                                            {
                                                                type: 'divider',
                                                            },
                                                            {
                                                                label: (
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleDownloadCSV(
                                                                                data[index]?.category,
                                                                                data[index]?.account,
                                                                                parameterone,
                                                                                parametertwo
                                                                            );
                                                                        }}
                                                                    >
                                                                        Download as CSV
                                                                    </a>
                                                                ),
                                                                key: `csv-${index}`,
                                                            },
                                                        ],
                                                    }}
                                                    trigger={['click']}
                                                >
                                                    <a
                                                        onClick={(e) => e.preventDefault()}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 10,
                                                            right: 10,
                                                            zIndex: 10,
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <Space>
                                                            <img src={download} alt="Download" style={{ width: 25 }} title="Download"/>
                                                        </Space>
                                                    </a>
                                                </Dropdown>

                                                <div key={`chart_${index}`}>
                                                    <div className="line-chart pb-1" ref={(el) => (domEls.current[index] = el)}>

                                                        <div style={{ maxWidth: "100%", margin: "0 auto", height: "500px", paddingTop: "40px" }} >
                                                            <ResponsiveContainer>
                                                                {data ? (
                                                                    <LineChart
                                                                        data={data[index]?.data}
                                                                        margin={{
                                                                            top: 5,
                                                                            right: 10,
                                                                            left: 20,
                                                                            bottom: 5,
                                                                        }}
                                                                    >

                                                                        <XAxis xAxisId="0" dataKey="flow_times_format" tick={false} angle={-45} textAnchor="end" />
                                                                        <XAxis dataKey="flow_date_format" allowDuplicatedCategory={false} xAxisId="1" />
                                                                        <YAxis type="number">
                                                                            <Label
                                                                                value="Gallons"
                                                                                position="insideLeft"
                                                                                angle={-90}
                                                                                style={{ textAnchor: 'middle', fontSize: '18px', fontWeight: '600' }}
                                                                            />
                                                                        </YAxis>
                                                                        <Legend formatter={(value, entry) => (
                                                                            <span>
                                                                                {data[index]?.account}
                                                                            </span>
                                                                        )} />

                                                                        <Line
                                                                            key="flow"
                                                                            type="monotone"
                                                                            dataKey="flow"
                                                                            stroke={color[0]}
                                                                            activeDot={{ r: 8 }}
                                                                            fill="#4285F4"
                                                                            strokeWidth={3}
                                                                            dot={(props) => (
                                                                                <Dot
                                                                                    {...props}
                                                                                    fill={data[index]?.data[props.index]?.anomaly === -1 ? 'red' : '#4285F4'}
                                                                                    r={data[index]?.data[props.index]?.anomaly === -1 ? 6 : 3}
                                                                                />
                                                                            )}
                                                                        />


                                                                        <CartesianGrid stroke="lightGrey" />
                                                                        <Tooltip />

                                                                    </LineChart>
                                                                ) : (
                                                                    <div className="chart-placeholder">

                                                                    </div>
                                                                )}
                                                            </ResponsiveContainer>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    ))}
                                </div>
                            </div>
                        </div>


                    </div>



                </div>
            </Main>
        </>
    )
};

export default Anomaly;


